import { CoverageCellStatus } from '../../components/siterag/coverage/coverageMatrixUi';
import { STRONG_STRUCTURED_FRACTION } from './evaluateRequirementCompleteness';

export function rowActionHint(
  status: CoverageCellStatus,
  matchCount: number,
  fill: { filled: number; total: number } | null,
  isCritical: boolean,
): string | null {
  if (status === 'missing') return 'No matching documents found — upload one.';
  if (status === 'tentative') {
    return matchCount > 0
      ? `${matchCount} doc${matchCount === 1 ? '' : 's'} matched but not extracted — upload clearer doc or author manually.`
      : 'Weak match only — upload a document or author manually.';
  }
  if (status === 'adequate' && fill && fill.total > 0) {
    const strongThreshold = Math.ceil(fill.total * STRONG_STRUCTURED_FRACTION);
    const needed = strongThreshold - fill.filled;
    if (needed > 0 && needed <= 5) return `${needed} more field${needed === 1 ? '' : 's'} to reach Strong.`;
  }
  return null;
}
